import _get from "lodash/get";
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { baseTheme } from '~base-theme';
import PlaceholderContainer from './PlaceholderContainer';

var Placeholder = function Placeholder(_ref) {
  var height = _ref.height,
      width = _ref.width,
      fill = _ref.fill,
      strokeColor = _ref.strokeColor,
      strokeSize = _ref.strokeSize;
  var theme = useContext(ThemeContext);

  var defaultFill = _get(theme, 'base.grays.grayLightest', baseTheme.base.grays.grayLightest);

  return /*#__PURE__*/React.createElement(PlaceholderContainer, null, /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 " + width + " " + height
  }, /*#__PURE__*/React.createElement("rect", {
    fill: fill || defaultFill,
    stroke: strokeColor,
    strokeWidth: strokeSize,
    width: width,
    height: height
  })));
};

Placeholder.defaultProps = {
  fill: undefined,
  strokeColor: null,
  strokeSize: 0
};
export default Placeholder;